import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Job } from '~hooks/useJob/models';
import { Load } from '~hooks/useLoad/models';
import { Ticket } from '~hooks/useTickets/models';

import { columns, gridTemplateColumns } from './settlement-loads-table-columns';
import SettlementLoadsTableRow from './SettlementLoadsTableRow';

interface SettlementLoadsTableProps {
  jobs: Job[];
  loads: Load[];
  onTableRowClick: (loadNumber: number, load: Load, ticket?: Ticket) => void;
  tickets: Ticket[];
}

export default function SettlementLoadsTable({
  jobs,
  loads,
  onTableRowClick,
  tickets,
}: SettlementLoadsTableProps) {
  return (
    <Box
      sx={(theme) => ({
        borderInline: `solid 1px ${theme.semantic.border}`,
        borderTop: `solid 1px ${theme.semantic.border}`,
        display: 'grid',
        gridAutoRows: 'auto',
        gridTemplateColumns,
        gridTemplateRows: '35px',
      })}
    >
      {columns.map((column) => (
        <Box
          key={column.key}
          sx={[
            (theme) => ({
              alignItems: 'center',
              bgcolor: theme.semantic.surfaceSunken,
              borderBottom: `solid 1px ${theme.semantic.border}`,
              display: 'flex',
              height: '100%',
              overflow: 'hidden',
            }),
            ...(Array.isArray(column.sx) ? column.sx : [column.sx]),
          ]}
        >
          {column.title && (
            <OverflowAwareText sx={{ fontWeight: 600 }}>{column.title}</OverflowAwareText>
          )}
        </Box>
      ))}

      {loads.map((load, index) => {
        const ticket = tickets.find((t) => t.loadId === load.id);
        const job = jobs.find((j) => j.id === load.jobId);

        return (
          <SettlementLoadsTableRow
            key={load.id}
            job={job}
            load={load}
            loadNumber={index + 1}
            onClick={onTableRowClick}
            ticket={ticket}
          />
        );
      })}
    </Box>
  );
}
